import { money } from "@/lib/api";

const STATUS_STYLES = {
  active: { dot: "#10B981", text: "text-emerald-400", bg: "bg-emerald-500/10 border-emerald-500/30", pulse: true },
  paused: { dot: "#F59E0B", text: "text-amber-400", bg: "bg-amber-500/10 border-amber-500/30" },
  paused_needs_funds: { dot: "#F59E0B", text: "text-amber-400", bg: "bg-amber-500/10 border-amber-500/30", pulse: true },
  decommissioned: { dot: "#64748B", text: "text-slate-400", bg: "bg-slate-500/10 border-slate-500/30" },
  frozen: { dot: "#EF4444", text: "text-red-400", bg: "bg-red-500/10 border-red-500/30" },
  killed: { dot: "#64748B", text: "text-slate-400", bg: "bg-slate-500/10 border-slate-500/30" },
  unassigned: { dot: "#64748B", text: "text-slate-400", bg: "bg-slate-500/10 border-slate-500/30" },
  ai: { dot: "#06B6D4", text: "text-cyan-400", bg: "bg-cyan-500/10 border-cyan-500/30", pulse: true },
  human: { dot: "#F59E0B", text: "text-amber-400", bg: "bg-amber-500/10 border-amber-500/30" },
  pending: { dot: "#F59E0B", text: "text-amber-400", bg: "bg-amber-500/10 border-amber-500/30" },
  executed: { dot: "#10B981", text: "text-emerald-400", bg: "bg-emerald-500/10 border-emerald-500/30" },
  approved: { dot: "#10B981", text: "text-emerald-400", bg: "bg-emerald-500/10 border-emerald-500/30" },
  blocked: { dot: "#EF4444", text: "text-red-400", bg: "bg-red-500/10 border-red-500/30" },
  rejected: { dot: "#EF4444", text: "text-red-400", bg: "bg-red-500/10 border-red-500/30" },
  paid: { dot: "#10B981", text: "text-emerald-400", bg: "bg-emerald-500/10 border-emerald-500/30" },
  draft: { dot: "#64748B", text: "text-slate-400", bg: "bg-slate-500/10 border-slate-500/30" },
  pending_payment: { dot: "#F59E0B", text: "text-amber-400", bg: "bg-amber-500/10 border-amber-500/30" },
  generating: { dot: "#06B6D4", text: "text-cyan-400", bg: "bg-cyan-500/10 border-cyan-500/30", pulse: true },
  deploying: { dot: "#F59E0B", text: "text-amber-400", bg: "bg-amber-500/10 border-amber-500/30", pulse: true },
  live: { dot: "#10B981", text: "text-emerald-400", bg: "bg-emerald-500/10 border-emerald-500/30", pulse: true },
  failed: { dot: "#EF4444", text: "text-red-400", bg: "bg-red-500/10 border-red-500/30" },
  awaiting_approval: { dot: "#F59E0B", text: "text-amber-400", bg: "bg-amber-500/10 border-amber-500/30" },
  info: { dot: "#06B6D4", text: "text-cyan-400", bg: "bg-cyan-500/10 border-cyan-500/30" },
  warn: { dot: "#F59E0B", text: "text-amber-400", bg: "bg-amber-500/10 border-amber-500/30" },
  critical: { dot: "#EF4444", text: "text-red-400", bg: "bg-red-500/10 border-red-500/30" },
};

export function StatusBadge({ status, testid }) {
  const s = STATUS_STYLES[status] || STATUS_STYLES.killed;
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-md border text-[10px] font-mono font-semibold uppercase tracking-wider ${s.bg} ${s.text}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${s.pulse ? "pulse-dot" : ""}`} style={{ backgroundColor: s.dot }} />
      {String(status).replace(/_/g, " ")}
    </span>
  );
}

const ACCENTS = { cyan: "#06B6D4", emerald: "#10B981", amber: "#F59E0B", crimson: "#EF4444", slate: "#334155" };

export function StatTile({ label, value, sub, accent = "cyan", icon: Icon, testid }) {
  return (
    <div className="hud-card accent-top rounded-lg p-5" style={{ "--accent-line": ACCENTS[accent] }} data-testid={testid}>
      <div className="flex items-start justify-between">
        <span className="font-mono text-[10px] font-semibold tracking-[0.2em] uppercase text-slate-400">{label}</span>
        {Icon && <Icon className="w-4 h-4 text-slate-500" />}
      </div>
      <div className="mt-3 font-mono font-bold tabular-nums text-2xl text-slate-50">{value}</div>
      {sub && <div className="mt-1 text-xs text-slate-500">{sub}</div>}
    </div>
  );
}

export function Overline({ children }) {
  return <div className="font-mono text-[10px] font-semibold tracking-[0.2em] uppercase text-slate-400">{children}</div>;
}

export { money };
